import { render, staticRenderFns } from "./BookingInputDetailView.vue?vue&type=template&id=748b0639&scoped=true&"
import script from "./BookingInputDetailView.vue?vue&type=script&lang=js&"
export * from "./BookingInputDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b0639",
  null
  
)

export default component.exports